import script from "./PortalPager.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortalPager.vue?vue&type=script&setup=true&lang=ts"

import "./PortalPager.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__